import AccessTypePill from "@components/Accesses/components/AccessTypePill";
import {
  getAccessPresentation,
  type AccessTypeOptions,
  type EventKind,
} from "@libs/utils";

type AccessBadgeProps = {
  access: {
    type: AccessTypeOptions;
    kind?: EventKind | null;
    extLinks?: string[] | null;
  };
};

export const AccessBadge = ({ access }: AccessBadgeProps) => {
  const presentation = getAccessPresentation({
    type: access.type,
    eventKind: access.kind,
    externalLinks: access.extLinks,
  });

  return presentation ? <AccessTypePill presentation={presentation} /> : null;
};
